module.exports = __webpack_public_path__ + "static/media/1280px-Ternium_Logo.svg.0fe83ca8.png";